import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { afterItems, beforeItems, concepts } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-53" data-mp="26n5vk7m2820x">
      <div className="mx-auto max-w-5xl" data-id="element-54" data-mp="22kr97dj6mk4w">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-55" data-mp="22m2exiw6u1yn">
          From “What do I do next?” to having a <em className="text-brand-600" data-id="element-56" data-mp="2ubxgcdxbli3o">system</em> for your next decision
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-57" data-mp="2ua48ivaz0ru3">
          Orthodontics feels very different when you’re studying individual concepts versus sitting in front of an actual
          patient. You may know:
        </p>
        <ul className="mx-auto mt-5 flex max-w-2xl flex-wrap justify-center gap-2" data-id="element-58" data-mp="1evybpcmww486">
          {concepts.map(c => <li key={c} className="rounded-lg border border-brand-200 bg-brand-50 px-3 py-1.5 text-sm font-semibold text-brand-800" data-id="element-59" data-mp="19usildpcaey4">
              {c}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-60" data-mp="1c3nxqi6vmw3e">
          But knowing them separately doesn’t tell you{' '}
          <strong className="text-ink" data-id="element-61" data-mp="132zixl9nsrpg">which one matters most in this case.</strong> That’s the gap this system addresses.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-62" data-mp="odbisnd7rz3b">
          <div className="rounded-3xl border-2 border-danger/20 bg-[#FDF3F3] p-6 sm:p-8" data-id="element-63" data-mp="t64mr90uz3ec">
            <p className="inline-flex items-center gap-2 rounded-full bg-danger px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-64" data-mp="fegb16uiugxw">
              <XCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-65" data-mp="jg1j8ew4271r" /> Before
            </p>
            <ul className="mt-6 space-y-4" data-id="element-66" data-mp="5giocnsb8s7e">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/80" data-id="element-67" data-mp="adsa9tghqlqh">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-68" data-mp="2c5atnev9quc8" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-brand-800 p-6 sm:p-8" data-id="element-69" data-mp="23d0l0200uwx3">
            <p className="inline-flex items-center gap-2 rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-70" data-mp="1ycur0f6a4ybu">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="2v1u0tymii865" /> With Ortho Decision System™
            </p>
            <ul className="mt-6 space-y-4" data-id="element-72" data-mp="2r2bc0rrklcy1">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-white" data-id="element-73" data-mp="2m0vtb6cv7iit">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#5BE08A]" aria-hidden="true" data-id="element-74" data-mp="2h2kiasau31z0" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 border-t border-white/15 pt-5 text-[15px] font-semibold text-brand-100" data-id="element-75" data-mp="15n5lppmjec4f">
              Every case follows the same decision architecture, even when the clinical situation is different.
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-76" data-mp="15ig51b8kby71">
          <CtaButton label="I want the decision system" data-id="element-77" data-mp="15i6e9lfp1n0a" />
        </div>
      </div>
    </section>;
}